import { SxProps } from "@mui/material";
import Box from "@mui/material/Box";
import Container, { ContainerProps } from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import * as React from "react";
import {
  Breadcrumb,
  PageHeader,
  PageHeaderProps,
} from "../PageHeader/PageHeader";

export interface PageContainerSlotProps {
  header: PageHeaderProps;
}

export interface PageContainerSlots {
  /**
   * The component that renders the page header.
   * @default PageHeader
   */
  header: React.ElementType;
}

export interface PageContainerProps extends ContainerProps {
  children?: React.ReactNode;
  /**
   * The title of the page. Leave blank to use the active page title.
   */
  title?: string;
  /**
   * The breadcrumbs of the page. Leave blank to use the active page breadcrumbs.
   */
  breadcrumbs?: Breadcrumb[];
  /**
   * The components used for each slot inside.
   */
  slots?: PageContainerSlots;
  /**
   * The props used for each slot inside.
   */
  slotProps?: PageContainerSlotProps;
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps;
}
function PageContainer(props: PageContainerProps) {
  const { children, breadcrumbs, slots, slotProps, title, ...rest } = props;

  const PageHeaderSlot = slots?.header ?? PageHeader;

  return (
    <Container
      {...rest}
      sx={{ flex: 1, display: "flex", flexDirection: "column", ...rest.sx }}
    >
      <Stack sx={{ flex: 1, my: 2 }} spacing={2}>
        <PageHeaderSlot
          title={title}
          breadcrumbs={breadcrumbs}
          {...slotProps?.header}
        />
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          {children}
        </Box>
      </Stack>
    </Container>
  );
}

export { PageContainer };
